import { motion } from 'motion/react'
import type { LucideIcon } from 'lucide-react'

interface EmptyStateProps {
  icon: LucideIcon
  title: string
  description: string
  action?: { label: string; onClick: () => void }
}

export default function EmptyState({ icon: Icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-6 text-center">
      <div className="animate-float mb-4">
        <Icon size={40} className="text-gold/30" />
      </div>
      <h3 className="font-display text-ivory text-base font-semibold mb-1">{title}</h3>
      <p className="text-pearl/60 text-sm leading-relaxed max-w-[240px]">{description}</p>
      {action && (
        <motion.button
          whileTap={{ scale: 0.95 }}
          onClick={action.onClick}
          className="mt-4 px-4 py-2 rounded-full bg-gold/10 border border-gold/20 text-gold text-sm font-medium hover:bg-gold/20 transition-colors"
        >
          {action.label}
        </motion.button>
      )}
    </div>
  )
}
